// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"1679d11f","227":"b3e730a9","271":"956193af","787":"f800d03a"}[chunkId] + ".chunk.js";
};